//@flow
import I18n from './i18n';
import type { CountryType } from '../config/iddCountries';

const getCountriesByProps = (propName: string, countries: ?(CountryType[]), propValue: ?string): CountryType[] => {
  if (!countries) return [];
  const filteredCountries = countries.filter(country => {
    if (!country[propName]) return false;
    if (!propValue) return true;
    return country[propName] === propValue;
  });
  return addNameAndSortCountries(filteredCountries);
};

export const getRoamingGroupCountries = (countries: ?(CountryType[]), roamingGroup: ?string): CountryType[] =>
  getCountriesByProps('callFromAbroad', countries, roamingGroup);

export const getIddZoneCountries = (countries: ?(CountryType[]), iddZone: ?string): CountryType[] =>
  getCountriesByProps('iddZone', countries, iddZone);

export const getTravelZoneCountries = (countries: ?(CountryType[]), travelZone: ?string): CountryType[] =>
  getCountriesByProps('travelZone', countries, travelZone);

const addNameAndSortCountries = (countries: CountryType[]): CountryType[] => {
  return countries
    .map(country => ({
      name: I18n.t(`countries.${country.id}`),
      ...country,
    }))
    .sort(compareCountries);
};

export const compareCountries = (country1: CountryType, country2: CountryType): number => {
  return country1.name.localeCompare(country2.name);
};
